const initialState = {
  id: undefined,
  amount: '',
  payer: undefined,
  due_by: undefined,
  name: '',
  payment_method: undefined,
  errors: [],
  ui: {
    show: false,
    is_submitting: false,
  }
} 

export default function makePaymentForm(state=initialState, action){
  switch(action.type){
    case "UPDATE_MAKE_PAYMENT_UI":
     return {
        ...state,
        ui: {
          ...state.ui,
          ...action.payload,
        }
     }
    case "UPDATE_MAKE_PAYMENT_FIELD":
      return {
        ...state,
        ...action.payload
      }
    case "BEGIN_SUBMIT_MAKE_PAYMENT":
      return {
        ...state,
        ui: {
          ...state.ui,
          is_submitting: true,
        },
      };
    case "SUCCESS_SUBMIT_MAKE_PAYMENT":
      return {
        ...initialState,
      };
    case "FAILED_SUBMIT_MAKE_PAYMENT":
      return {
        ...state,
        errors: action.payload,
        ui: {
          ...state.ui,
          is_submitting: false,
        }
      }
    case "RESET_MAKE_PAYMENT_FORM":
      return initialState;
    case "LOAD_MAKE_PAYMENT":
      return {
        ...state,
        ...action.payload,
        ui: {
          ...state.ui,
          show: true,
        }
      }
    default: 
      return state
  }
}